import React, { useState, useEffect } from 'react';
import { ShoppingCart, Share2, Code, Database, Server, Globe, Codepen, ChevronDown, Box } from 'lucide-react'; // Replaced FastFood with Box
import './projectShowcase.css';

import saas from './saas-img.png';
import shareMeImg from './social-img.png';
import foodDeliveryImg from './food-img.jpg';
import shoppingCartImg from './shop-img.png';

const ProjectShowcase = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const images = [saas, shareMeImg, foodDeliveryImg, shoppingCartImg];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [images]);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const projects = [
    {
      title: "ShareMe - Social Media Web Application",
      link: 'https://drive.google.com/file/d/1dvBDHuvh9ZmZv7Ifj62mbx3ojuXWXPxG/view?usp=sharing',
      icon: <Share2 size={16} />
    },
    {
      title: "Food Delivery Application",
      link: 'https://github.com/Ashishkr05/food-delivery-REST_API-app',
      icon: <Box size={16} /> // Updated icon here
    },
    {
      title: "E-commerce Shopping Cart",
      link: 'https://github.com/Ashishkr05/ecommerce-shopping-cart',
      icon: <ShoppingCart size={16} />
    }
  ];

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const features = [
    { text: "🔄 Real-time Web Application" },
    { text: "💳 Secure Payment Integration" },
    { text: "📦 Order Tracking System" },
    { text: "🌐 Social Media Integration" },
    { text: "🏛️ Scalable Backend Architecture" },
    { text: "🗄️ Database Management" }
  ];
  
  const technologies = [
    { text: "⚛️ React.js (Frontend)" },
    { text: "🟢 Node.js & Express.js (Backend)" },
    { text: "🍃 MongoDB (NoSQL Database)" },
    { text: "🧩 MERN Stack (Full-Stack)" },
    { text: "🔗 RESTful API Integration" },
    { text: "🚀 Cloud Deployment (AWS)" }
  ];

  return (
    <div className="project-showcase">
      <div className="showcase-content">
        <div className="image-carousel">
          <img
            src={images[currentImageIndex]}
            alt={`SaaS Solution ${currentImageIndex + 1}`}
          />
          <div className="dots-container">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentImageIndex === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
        <div className="project-details">
          <h2>☁️ Software as a Service (SaaS) Solutions</h2>
          <p>
          I developed SaaS Solutions to create dynamic, user-focused applications tailored to specific needs. This category includes projects like ShareMe, a social media image-sharing platform, a Food Delivery App, and an E-commerce Shopping Cart. Each of these projects was built individually with a focus on delivering seamless user experiences, efficient functionality, and scalable designs to meet the demands of various industries.
          </p>
          <div className="features-technologies">
            <div className="column">
              <h3>Key Features</h3>
              {features.map((item, index) => (
                <div key={index} className="item">
                  {item.icon}
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
            <div className="column">
              <h3>Technologies Used</h3>
              {technologies.map((item, index) => (
                <div key={index} className="item">
                  {item.icon}
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="project-dropdown">
            <button className="dropdown-button" onClick={toggleDropdown}>
              Explore SaaS Products I’ve Worked On <ChevronDown size={16} />
            </button>
            <div className={`dropdown-content ${dropdownOpen ? 'show' : ''}`}>
              {projects.map((project, index) => (
                <a
                  key={index}
                  href={project.link}
                  className="project-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {project.icon}
                  <span>{project.title}</span>
                </a>
              ))}
            </div>
          </div>
          <p className="dropdown-note">Click on a product to view detailed information and implementation guides.</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectShowcase;
